module.exports = __webpack_public_path__ + "assets/img/37_970_big.afb08510.jpg";